import { SeguridadUsuarioActual } from './../../../../../framework/modelo/seguridad/SeguridadUsuarioActual';
import { Injectable } from '@angular/core';
import { AppConfig } from '@env/appconfig';
import { JWT_RESPONSE_HEADER } from './../../../constantes';
import { SeguridadUsuarioLogin } from 'src/app/royal/framework/modelo/seguridad/SeguridadUsuarioLogin';
import { DtoTabla } from 'src/app/royal/framework/modelo/generico/dto/DtoTabla';
import { DtoConfiguracionLogin } from '../../../dominio/DtoConfiguracionLogin';

@Injectable()
export class LoginService {
    private url = `${this.config.getEnv('spring-framework-seguridad-api')}autorizacion/seguridad/login/`;

    constructor(private config: AppConfig) {
    }

    wf_setup_compania_usuario(body: SeguridadUsuarioLogin): Promise<DtoTabla[]> {
        return this.config.getHttp().put(`${this.url}wf_setup_compania_usuario`, body)
            .toPromise()
            .then(response => response as DtoTabla[])
            .catch(error => null);
    }

    listarcompaniasporusuario(body: SeguridadUsuarioLogin): Promise<DtoTabla[]> {
        return this.config.getHttp().put(`${this.url}listarcompaniasporusuario`, body)
            .toPromise()
            .then(response => response as DtoTabla[])
            .catch(error => null);
    }

    ingresar(body: SeguridadUsuarioLogin): Promise<SeguridadUsuarioLogin> {
        return this.config.getHttp().put(`${this.url}ingresar`, body)
            .toPromise()
            .then(response => this.saveToken(response as SeguridadUsuarioLogin)
            )
            .catch(error => null);
    }

    generarTokenAD(): Promise<SeguridadUsuarioLogin> {
        return this.config.getHttp().get(`${this.url}generarTokenAD`)
            .toPromise()
            .then(response => this.saveToken(response as SeguridadUsuarioLogin)
            )
            .catch(error => null);
    }

    configuracionLogin(): Promise<DtoConfiguracionLogin> {
        return this.config.getHttp().get(`${this.url}configuracionLogin`)
            .toPromise()
            .then(response => response as DtoConfiguracionLogin
            )
            .catch(error => new DtoConfiguracionLogin());
    }

    public recuperarClave(bean: DtoTabla): Promise<any[]> {
        return this.config.getHttp().post(`${this.url}recuperarclave`, bean)
            .toPromise()
            .then(response => response as any[])
            .catch(error => []);
    }

    autologin(body: SeguridadUsuarioLogin): Promise<SeguridadUsuarioLogin> {
        return this.config.getHttp().post(`${this.url}autologin`, body)
            .toPromise()
            .then(response => this.saveToken(response as SeguridadUsuarioLogin)
            )
            .catch(error => null);
    }


    private saveToken(res: SeguridadUsuarioLogin): any {
        const token = res.token;
        if (token) {
            localStorage.setItem(JWT_RESPONSE_HEADER, token);
        }
        return res;
    }



}